// extracted by mini-css-extract-plugin
module.exports = {"root":"FAQs_root__xhxJG","faqWrapper":"FAQs_faqWrapper__f51qA"};